// extracted by mini-css-extract-plugin
export default {"card":"TestimonialCard_card__IfEl1","image":"TestimonialCard_image__gI9qB","cardHeading":"TestimonialCard_cardHeading__RGXwK"};